import { render, staticRenderFns } from "./FlightInfo.vue?vue&type=template&id=2cedd9b1&"
import script from "./FlightInfo.vue?vue&type=script&lang=js&"
export * from "./FlightInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports